var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('main-header-plat-a'),_c('main-header-plat-b',{attrs:{"navBItems":_vm.navBItems}}),_c('v-overlay-loader')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }